export default __webpack_public_path__ + "static/media/img16.5656a7a2.PNG";